/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

console.log("Loading Here");

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function () {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

/**
 * custom filter & breadcrumbs
 */

var categoryFilters = document.querySelectorAll(
  ".template-collection .Linklist__Item.category .Link"
);
var breadcrumbFilter = document.querySelector(
  ".template-collection .breadcrumbs .tags .breadcrumbs__link"
);
categoryFilters.forEach(function (item, index) {
  item.addEventListener("click", function () {
    console.log(this.dataset);
    breadcrumbFilter.innerHTML = this.innerHTML;
    breadcrumbFilter.setAttribute("href", this.dataset.tagurl);
  });
});
